
export default {
  internal: 'Internal',
  thirdParty: 'Third Party'
}
